import React from "react";
import "./helpPanel.css";
import { AppBar } from "./appBar";
import { PageHeading } from "./pageHeading";

export interface IHelpPanelProps {
  open: boolean;
  onClose: () => void;
}

/** "How to play" — a full-screen overlay explainer. Shown on first run and from
 *  the Home "How to play" link. Controlled via `open` / `onClose`. */
export function HelpPanel({ open, onClose }: IHelpPanelProps) {
  if (!open) {
    return null;
  }

  return (
    <div className="howto-overlay" role="dialog" aria-modal="true" aria-label="How to play">
      <div className="screen howto">
        <AppBar onBack={onClose} />
        <PageHeading
          eyebrow="Getting started"
          title="How to play"
          sub={<>A daily word hunt&mdash;with a rare twist.</>}
        />

        <div className="howto__body">
          <div className="howto__sub">
            Find as many words as you can before the clock runs out. The rarer the word, the more
            it&rsquo;s worth.
          </div>

          <div className="howto__board">
            {["W", "O", "N", "S"].map((l, i) => (
              <div key={`a${i}`} className={`tile${i < 3 ? " tile--sel" : ""}`}>
                {l}
              </div>
            ))}
            {["A", "D", "E", "R"].map((l, i) => (
              <div
                key={`b${i}`}
                className={`tile${i === 1 || i === 2 ? " tile--sel" : ""}${
                  i === 3 ? " tile--tail" : ""
                }`}
              >
                {l}
              </div>
            ))}
            {["T", "I", "L", "K"].map((l, i) => (
              <div key={`c${i}`} className="tile">
                {l}
              </div>
            ))}
            {["P", "U", "C", "M"].map((l, i) => (
              <div key={`d${i}`} className="tile">
                {l}
              </div>
            ))}
          </div>
          <div className="howto__cap">
            Trace adjacent letters to spell <b>wonder</b>
          </div>

          {[
            {
              t: "Trace a word",
              d: "Connect adjacent letters in any direction\u2014including diagonals. Lift to score it, or tap letters then Score word.",
            },
            {
              t: "Reuse letters, not tiles",
              d: "A letter can repeat if it appears more than once\u2014but you can\u2019t use the same tile twice in one word.",
            },
            {
              t: "Beat the clock",
              d: "You have a few minutes once you begin. Stuck? Rotate the board for a fresh angle.",
            },
            {
              t: "Come back tomorrow",
              d: "Rare-word bonuses are revealed the next day\u2014see which of your finds few others spotted.",
            },
          ].map((s, i) => (
            <div className="howto__step" key={i}>
              <div className="howto__step-n">{i + 1}</div>
              <div>
                <div className="howto__step-t">{s.t}</div>
                <div className="howto__step-d">{s.d}</div>
              </div>
            </div>
          ))}

          <button className="btn btn--primary howto__cta" onClick={onClose}>
            Got it &mdash; let&rsquo;s play
          </button>
        </div>
      </div>
    </div>
  );
}
